import {createContext} from 'react';

const depositosContext = createContext();

export default depositosContext;